import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Splitter } from "@progress/kendo-react-layout";
import { ListView } from "@progress/kendo-react-listview";
import { Button } from "@progress/kendo-react-buttons";
import { LoadingPanel } from "../../LoadingPanel";
import { AdministratorTicketingWebsiteAlert } from "./TicketingWebsiteAlert";
import { TextBox, InputClearValue  } from "@progress/kendo-react-inputs";
import { Pager } from "@progress/kendo-react-data-tools";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Icon } from "@progress/kendo-react-common";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { ScreenSize } from '../../../app/ScreenSize';
import { GetScreenSize } from '../../../app/GetScreenSize';
import { getCSRFToken } from '../../../app/getCSRFToken';
import useSpeechToText from 'react-hook-speech-to-text';

import './TicketingWebsiteAlerts.scss';

export const AdministratorTicketingWebsiteAlerts = () => {
    const dispatch = useDispatch();

    const activeFilterOption = {
        name: "Active",
        value: "true",
    };
    const isActiveFilterOptions = [
        {
            name: "Active and Inactive",
            value: ""
        },
        activeFilterOption,
        {
            name: "Inactive",
            value: "false",
        }
    ];

    const [ticketingWebsiteAlerts, setTicketingWebsiteAlerts] = useState([]);
    const [ticketingWebsiteAlertsPagerData, setTicketingWebsiteAlertsPagerData] = useState({
        total: 0,
        skip: 0,
        take: 1
    });
    const [selectedTicketingWebsiteAlertKey, setSelectedTicketingWebsiteAlertKey] = useState(null);
    const [ticketingWebsiteAlert, setTicketingWebsiteAlert] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");
    const [doCreateNewTicketingWebsiteAlert, setDoCreateNewTicketingWebsiteAlert] = useState(false);
    const [ticketingWebsiteAlertNameFilterValue, setTicketingWebsiteAlertNameFilterValue] = useState("");
    const [isActiveTicketingWebsiteAlertsValue, setIsActiveTicketingWebsiteAlertsValue] = useState(activeFilterOption);
    const [ticketingWebsiteAlertLoading, setTicketingWebsiteAlertLoading] = useState(false);
    const [ticketingWebsiteIdFilterValue, setTicketingWebsiteIdFilterValue] = useState(null);

    const defaultTicketingWebsite = {
        ticketingWebsiteId: "",
        name: "All Websites",
    };
    const [ticketingWebsites, setTicketingWebsites] = useState([]);
    const [ticketingWebsitesFilterOptions, setTicketingWebsitesFilterOptions] = useState([defaultTicketingWebsite]);

    const defaultTicketStockType = {
        ticketStockTypeId: "",
        name: "Use Default",
    };
    const [ticketStockTypes, setTicketStockTypes] = useState([]);

    const defaultTicketDeliveryMethod = {
        ticketDeliveryMethodId: "",
        name: "Use Default",
    };
    const [ticketDeliveryMethods, setTicketDeliveryMethods] = useState([]);

    const typingTimeout = useRef();
    const typingTimeoutDelay = 500; //Milliseconds

    const {
        error,
        results,
        isRecording,
        startSpeechToText,
        stopSpeechToText,
    } = useSpeechToText({
        timeout: 1000
    });

    const standardPanes = [
        {
            size: "340px",
            min: "5%",
            resizable: false,
        },
        {}
    ];

    const getMobilePanes = () => {
        if (!ticketingWebsiteAlert && doCreateNewTicketingWebsiteAlert === false) {
            return [
                {
                    size: "100%",
                    resizable: false,
                },
                {
                    collapsed: true,
                }
            ];
        }

        return [
            {
                size: "100%",
                resizable: false,
                collapsed: true,
            },
            {
                              
            }
        ];
    }

    const renderTicketingWebsiteAlertListItem = (props) => {
        let item = props.dataItem;
        
        return (
            <div className={"ticketingWebsiteAlertListItem" + (item.ticketingWebsiteAlertKey === selectedTicketingWebsiteAlertKey ? " ticketingWebsiteAlertListItemSelected" : "")} onClick={() => selectTicketingWebsiteAlert(item.ticketingWebsiteAlertKey)}>
                <div className="ticketingWebsiteAlertListPrimaryText">
                    {item.label}
                </div>
                <div className="ticketingWebsiteAlertListSecondaryText">
                    {item.isActive ? "Active" : "Inactive"}
                    &nbsp;|&nbsp;
                    {ticketingWebsitesFilterOptions.find(element => element.ticketingWebsiteId === item.ticketingWebsiteId)?.name}
                </div>                
            </div>
        );
    }

    const selectTicketingWebsiteAlert = (ticketingWebsiteAlertKey) => {
        getTicketingWebsiteAlert(ticketingWebsiteAlertKey);
    }

    const createNewTicketingWebsiteAlert = () => {
        setTicketingWebsiteAlert(undefined);
        setSelectedTicketingWebsiteAlertKey(null);
        setTicketingWebsiteAlertLoading(false);
        setDoCreateNewTicketingWebsiteAlert(true);

        getTicketingWebsiteAlerts(ticketingWebsiteAlertNameFilterValue, isActiveTicketingWebsiteAlertsValue, ticketingWebsiteIdFilterValue, ticketingWebsiteAlertsPagerData.skip, ticketingWebsiteAlertsPagerData.take);
    }

    const clearTicketingWebsiteAlert = () => {
        setTicketingWebsiteAlert(undefined);
        setSelectedTicketingWebsiteAlertKey(null);
        setTicketingWebsiteAlertLoading(false);
        setDoCreateNewTicketingWebsiteAlert(false);

        getTicketingWebsiteAlerts(ticketingWebsiteAlertNameFilterValue, isActiveTicketingWebsiteAlertsValue, ticketingWebsiteIdFilterValue, ticketingWebsiteAlertsPagerData.skip, ticketingWebsiteAlertsPagerData.take);
    }

    const getTicketingWebsiteAlert = (ticketingWebsiteAlertKey) => {
        setSelectedTicketingWebsiteAlertKey(ticketingWebsiteAlertKey);
        setTicketingWebsiteAlertLoading(true);
        setDoCreateNewTicketingWebsiteAlert(false);

        const dataItem = {
            ticketingWebsiteAlertKey: ticketingWebsiteAlertKey,
        };

        fetch(`/api/administrator/getticketingwebsitealert`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setTicketingWebsiteAlert(result);
                setTicketingWebsiteAlertLoading(false);

                getTicketingWebsiteAlerts(ticketingWebsiteAlertNameFilterValue, isActiveTicketingWebsiteAlertsValue, ticketingWebsiteIdFilterValue, ticketingWebsiteAlertsPagerData.skip, ticketingWebsiteAlertsPagerData.take);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setTicketingWebsiteAlert(undefined);
                setTicketingWebsiteAlertLoading(false);
            });
    }

    const getTicketingWebsiteAlerts = (name, isActiveFilterOption, ticketingWebsite, skip, take) => {
        if (!skip) {
            skip = 0;
        }

        if (!take) {
            take = 1;
        }

        const pageNumber = (skip / take) + 1;

        let isActive;
        switch (isActiveFilterOption.value) {
            case "true":
                isActive = true;
                break;

            case "false":
                isActive = false;
                break;

            default:
                isActive = null;
                break;
        }

        const dataItem = {
            name: name,
            isActive: isActive,
            pageNumber: pageNumber,
            ticketingWebsiteId: ticketingWebsite?.ticketingWebsiteId !== "" ? ticketingWebsite?.ticketingWebsiteId : null,
        };

        fetch(`/api/administrator/ticketingwebsitealerts`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setLoading(false);
                setTicketingWebsiteAlerts(result.ticketingWebsiteAlerts);
                setTicketingWebsiteAlertsPagerData({
                    total: result.totalTicketingWebsiteAlertCount,
                    skip: (result.pageNumber - 1) * result.ticketingWebsiteAlertsPerPage,
                    take: result.ticketingWebsiteAlertsPerPage
                });
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
                
                setLoading(false);
                setLoadingError(error.message);
            });        
    }

    const getTicketingWebsites = () => {
        fetch(`/api/general/ticketingwebsites`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify({}),
            })
            .then(handleResponse)
            .then(result => {
                const allTicketingWebsites = [defaultTicketingWebsite].concat(result);
                setTicketingWebsites(result);
                setTicketingWebsitesFilterOptions(allTicketingWebsites);
                setTicketingWebsiteIdFilterValue(defaultTicketingWebsite);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const getTicketStockTypes = () => {
        fetch(`/api/general/ticketstocktypes`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify({}),
            })
            .then(handleResponse)
            .then(result => {
                const allTicketStockTypes = [defaultTicketStockType].concat(result);
                setTicketStockTypes(allTicketStockTypes);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const getTicketDeliveryMethods = () => {
        fetch(`/api/general/ticketdeliverymethods`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify({}),
            })
            .then(handleResponse)
            .then(result => {
                const allTicketDeliveryMethods = [defaultTicketDeliveryMethod].concat(result);
                setTicketDeliveryMethods(allTicketDeliveryMethods);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const handleTicketingWebsiteAlertPageChange = (event) => {
        const { skip, take } = event;

        setTicketingWebsiteAlertsPagerData({
            total: ticketingWebsiteAlertsPagerData.total,
            skip: skip,
            take: take
        });

        getTicketingWebsiteAlerts(ticketingWebsiteAlertNameFilterValue, isActiveTicketingWebsiteAlertsValue, ticketingWebsiteIdFilterValue, skip, take);
    };

    const ticketingWebsiteAlertNameFilterValueChangedEvent = (event) => {
        const value = event.value;
        ticketingWebsiteAlertNameFilterValueChanged(value); 
    }

    const ticketingWebsiteAlertNameFilterValueChanged = (value) => {
        clearTimeout(typingTimeout.current);
        setTicketingWebsiteAlertNameFilterValue(value);

        typingTimeout.current = setTimeout(() => {
            getTicketingWebsiteAlerts(value, isActiveTicketingWebsiteAlertsValue, ticketingWebsiteIdFilterValue);
        }, typingTimeoutDelay);      
    }

    const ticketingWebsiteAlertNameClearFilterValue = () => {
        setTicketingWebsiteAlertNameFilterValue("");
        getTicketingWebsiteAlerts("", isActiveTicketingWebsiteAlertsValue, ticketingWebsiteIdFilterValue);
    }

    const isActiveTicketingWebsiteAlertsValueChanged = (event) => {
        const value = event.value;

        setIsActiveTicketingWebsiteAlertsValue(value);
        getTicketingWebsiteAlerts(ticketingWebsiteAlertNameFilterValue, value, ticketingWebsiteIdFilterValue);
    }

    const ticketingWebsiteFilterValueChanged = (event) => {
        const value = event.value;
        
        setTicketingWebsiteIdFilterValue(value);
        getTicketingWebsiteAlerts(ticketingWebsiteAlertNameFilterValue, isActiveTicketingWebsiteAlertsValue, value);
    }

    useEffect(() => {
        document.title = "Ticketing Website Alerts";

        getTicketingWebsites();
        getTicketingWebsiteAlerts(ticketingWebsiteAlertNameFilterValue, isActiveTicketingWebsiteAlertsValue, ticketingWebsiteIdFilterValue);
        getTicketStockTypes();
        getTicketDeliveryMethods();
    }, []);

    useEffect(() => {
        if (!isRecording) {
            if (results.length > 0) {
                const speechValue = results.pop();
                ticketingWebsiteAlertNameFilterValueChanged(speechValue); 
            }
        }
    }, [isRecording]);
        
    return (
        <Splitter                
            panes={GetScreenSize() === ScreenSize.Mobile ? getMobilePanes() : standardPanes}
        >                
            <div>
                <div className="ticketingWebsiteAlertListFilterHeader">
                    <Button icon="plus" themeColor={"primary"} onClick={createNewTicketingWebsiteAlert}>Create New Alert</Button>
                </div>
                <div className="ticketingWebsiteAlertListFilter">
                    <div className="d-flex flex-row">
                        <TextBox
                            type={"text"}
                            maxLength={"50"}
                            value={ticketingWebsiteAlertNameFilterValue}
                            onChange={ticketingWebsiteAlertNameFilterValueChangedEvent}
                            placeholder={"Search part of alert name"}   
                            suffix={() => (
                                <>
                                    {ticketingWebsiteAlertNameFilterValue !== "" && (
                                        <InputClearValue onClick={ticketingWebsiteAlertNameClearFilterValue}>
                                            <Icon name="x" />
                                        </InputClearValue>
                                    )}                                
                                </>
                            )}
                        />

                        {!error && <Button className={isRecording ? "recordButton recording pt-2 pb-0 ms-2" : "recordButton pt-2 pb-0 ms-2"} iconClass="fa-solid fa-microphone" onClick={isRecording ? stopSpeechToText : startSpeechToText} />}
                    </div>
                    <div>
                        <DropDownList
                            data={ticketingWebsitesFilterOptions}
                            value={ticketingWebsiteIdFilterValue}
                            textField="name"
                            dataItemKey="ticketingWebsiteId"
                            onChange={ticketingWebsiteFilterValueChanged}
                        />
                    </div>
                    <div>
                        <DropDownList
                            data={isActiveFilterOptions}
                            value={isActiveTicketingWebsiteAlertsValue}
                            textField="name"
                            dataItemKey="value"
                            onChange={isActiveTicketingWebsiteAlertsValueChanged}
                        />
                    </div>
                </div>
                {loading ? <LoadingPanel /> : (loadingError === "" ? (
                    <>
                        <ListView
                            data={ticketingWebsiteAlerts}
                            item={renderTicketingWebsiteAlertListItem}
                        />
                        <Pager
                            skip={ticketingWebsiteAlertsPagerData.skip}
                            take={ticketingWebsiteAlertsPagerData.take}
                            total={ticketingWebsiteAlertsPagerData.total}
                            buttonCount={0}
                            info={true}
                            type={"numeric"}
                            previousNext={true}
                            onPageChange={handleTicketingWebsiteAlertPageChange}
                        />
                    </>) : <div></div>)}
            </div>
            <AdministratorTicketingWebsiteAlert
                ticketingWebsiteAlert={ticketingWebsiteAlert}
                loading={ticketingWebsiteAlertLoading}
                createNewTicketingWebsiteAlert={doCreateNewTicketingWebsiteAlert}
                cancel={clearTicketingWebsiteAlert}
                selectTicketingWebsiteAlert={selectTicketingWebsiteAlert}
                ticketingWebsites={ticketingWebsites}
                ticketStockTypes={ticketStockTypes}
                ticketDeliveryMethods={ticketDeliveryMethods}
            />
        </Splitter>
    );
}